import { render, staticRenderFns } from "./need.vue?vue&type=template&id=632b13ed&"
import script from "./need.vue?vue&type=script&lang=js&"
export * from "./need.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632b13ed')) {
      api.createRecord('632b13ed', component.options)
    } else {
      api.reload('632b13ed', component.options)
    }
    module.hot.accept("./need.vue?vue&type=template&id=632b13ed&", function () {
      api.rerender('632b13ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/workflow/userList/need.vue"
export default component.exports